module.exports = __webpack_public_path__ + "static/media/btn-x-close-small-gray.a77b233b.svg";